import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ImpersonationService, ImpersonatedUser } from '../../services/impersonation.service';

@Component({
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './impersonation-banner.component.html',
  styleUrl: './impersonation-banner.component.css'
})
export class ImpersonationBannerComponent implements OnInit, OnDestroy {
  impersonatedUser: ImpersonatedUser | null = null;
  private subscription: Subscription | null = null;

  constructor(private impersonationService: ImpersonationService) {}

  ngOnInit(): void {
    this.subscription = this.impersonationService.impersonatedUser$.subscribe(user => {
      this.impersonatedUser = user;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  stopImpersonation(): void {
    this.impersonationService.stopImpersonation();
    // Reload the page to reset all state
    window.location.reload();
  }

  getUserTypeLabel(): string {
    if (!this.impersonatedUser) return '';
    return this.impersonatedUser.type === 'member' ? 'Member' : 'User';
  }
}














